const WORD_TO_DIGIT = new Map([
  // RU
  ['ноль', '0'],
  ['один', '1'],
  ['два', '2'],
  ['три', '3'],
  ['четыре', '4'],
  ['пять', '5'],
  ['шесть', '6'],
  ['семь', '7'],
  ['восемь', '8'],
  ['девять', '9'],
  // EN
  ['zero', '0'],
  ['one', '1'],
  ['two', '2'],
  ['three', '3'],
  ['four', '4'],
  ['five', '5'],
  ['six', '6'],
  ['seven', '7'],
  ['eight', '8'],
  ['nine', '9'],
  // FR
  ['zéro', '0'],
  ['un', '1'],
  ['deux', '2'],
  ['trois', '3'],
  ['quatre', '4'],
  ['cinq', '5'],
  ['seis', '6'],
  ['sept', '7'],
  ['huit', '8'],
  ['neuf', '9'],
  // ES
  ['cero', '0'],
  ['uno', '1'],
  ['dos', '2'],
  ['tres', '3'],
  ['cuatro', '4'],
  ['cinco', '5'],
  ['seis', '6'],
  ['siete', '7'],
  ['ocho', '8'],
  ['nueve', '9'],
  // DE
  ['null', '0'],
  ['eins', '1'],
  ['zwei', '2'],
  ['drei', '3'],
  ['vier', '4'],
  ['fünf', '5'],
  ['sechs', '6'],
  ['sieben', '7'],
  ['acht', '8'],
  ['neun', '9'],
]);

const HOMOGLYPH_MAP = new Map([
  ['o', '0'],
  ['о', '0'],
  ['ø', '0'],
  ['º', '0'],
  ['i', '1'],
  ['l', '1'],
  ['|', '1'],
  ['!', '1'],
  ['¡', '1'],
  ['z', '2'],
  ['з', '3'],
  ['e', '3'],
  ['ч', '4'],
  ['@', '4'],
  ['s', '5'],
  ['$', '5'],
  ['б', '6'],
  ['b', '8'],
  ['&', '8'],
]);

const STOP_WORDS = [
  't.me',
  'telegram.me',
  'wa.me',
  'api.whatsapp.com',
  'vk.com',
  'instagram.com',
  'facebook.com',
  'm.me',
];

const PRICE_PREFIX_REGEX = /(цена|price|prix|precio|preis|€|\$|₽)\s*[:：]?\s*$/i;
const PRICE_SUFFIX_REGEX = /^\s*(рублей|руб|евро|euro|€|\$|₽)/i;
const EMAIL_REGEX =
  /[a-z0-9._%+-]+\s*@\s*[a-z0-9.-]+\s*\.\s*[a-z]{2,}/i;
const URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

// Phone-candidate alphabet. `@`, `$` and `&` are deliberately excluded from the
// homoglyph set: in real prose they are email/currency/ampersand, not digit
// look-alikes. `,`, `_` and `\` are deliberately excluded from the separator set:
// the comma is a list separator in service descriptions, not phone notation.
const PHONE_HOMOGLYPH_EXCLUSIONS = ['@', '$', '&'];
const PHONE_HOMOGLYPHS = new Map(
  [...HOMOGLYPH_MAP].filter(([char]) => !PHONE_HOMOGLYPH_EXCLUSIONS.includes(char))
);
const PHONE_SEPARATORS = new Set([
  ' ',
  '\t',
  '.',
  '-',
  '(',
  ')',
  '+',
  '/',
  '\u00a0',
  '\u2010',
  '\u2011',
  '\u2012',
  '\u2013',
  '\u2014',
  '\u2015',
]);

const MAX_SEPARATOR_RUN = 2;
const MIN_CANDIDATE_DIGITS = 7;
const BLOCK_MIN_LITERAL_DIGITS = 6;
const SUSPICIOUS_MIN_LITERAL_DIGITS = 4;

// Ordinary product-language vocabulary, used only by the date-shape branch.
const DATE_CONTEXT = new Set([
  'дата',
  'даты',
  'датой',
  'дате',
  'релиз',
  'версия',
  'версии',
  'выпуск',
  'date',
  'dates',
  'release',
  'version',
  'build',
  'fecha',
  'versión',
  'datum',
  'data',
  'versione',
]);

const PHONE_CONTEXT = new Set([
  'тел',
  'телефон',
  'телефона',
  'звони',
  'звоните',
  'позвони',
  'позвоните',
  'номер',
  'вотсап',
  'ватсап',
  'whatsapp',
  'вайбер',
  'viber',
  'phone',
  'tel',
  'call',
  'mobile',
  'cell',
  'téléphone',
  'telephone',
  'appelle',
  'portable',
  'teléfono',
  'telefono',
  'llama',
  'móvil',
  'movil',
  'telefon',
  'handy',
  'cellulare',
  'chiama',
]);

// Public TLD registry subsets. HIGH-confidence TLDs are never used in ordinary
// prose as a word, so a syntactically valid host is enough. Ambiguous TLDs are
// also ordinary words and require structural evidence.
const BARE_DOMAIN_HIGH_CONFIDENCE_TLDS = new Set([
  'com',
  'net',
  'org',
  'info',
  'biz',
  'io',
  'xyz',
  'online',
  'site',
  'website',
  'ru',
  'su',
  'fr',
  'it',
  'de',
  'es',
  'eu',
  'uk',
  'nl',
  'ch',
  'pl',
  'pt',
  'cz',
  'ua',
  'by',
  'kz',
  'ge',
  'am',
  'il',
  'ae',
  'ca',
  'tr',
  'cn',
  'jp',
  'br',
]);

const BARE_DOMAIN_AMBIGUOUS_TLDS = new Set([
  'one',
  'pro',
  'shop',
  'design',
  'studio',
  'agency',
  'life',
  'live',
  'top',
  'club',
  'space',
  'store',
  'app',
  'dev',
  'tech',
  'me',
  'co',
  'art',
  'blog',
  'digital',
  'expert',
  'guru',
  'works',
]);

// ASCII-only labels keep non-ASCII prose (e.g. `Психолог.коуч`) out of the match.
const BARE_DOMAIN_REGEX = /(?<![\p{L}\p{N}@._-])((?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,})(\/[^\s]*|\?[^\s]*)?(?![\p{L}\p{N}-])/giu;

const PREVIOUS_WORD_REGEX = /([\p{L}]+)[^\p{L}\p{N}]*$/u;

const countWordDigits = text => {
  const words = text.split(/[^\p{L}\p{N}]+/gu).filter(Boolean);
  return words.reduce((count, word) => (WORD_TO_DIGIT.has(word) ? count + 1 : count), 0);
};

const replaceWordDigits = text => {
  return text.replace(/\b[\p{L}\p{N}]+\b/gu, match =>
    WORD_TO_DIGIT.has(match) ? WORD_TO_DIGIT.get(match) : match
  );
};

const replaceHomoglyphs = text => {
  return Array.from(text)
    .map(ch => HOMOGLYPH_MAP.get(ch) || ch)
    .join('');
};

export const normalizeText = text => {
  const lower = `${text || ''}`
    .toLowerCase()
    .replace(/\[(at|dot)\]/gi, match => (match.toLowerCase() === '[at]' ? '@' : '.'))
    .replace(/\((at|dot)\)/gi, match => (match.toLowerCase() === '(at)' ? '@' : '.'));
  const shouldReplaceWords = countWordDigits(lower) >= 3;
  const wordReplaced = shouldReplaceWords ? replaceWordDigits(lower) : lower;
  return replaceHomoglyphs(wordReplaced);
};

/**
 * Phone pre-normalization. Deliberately does NOT substitute homoglyphs:
 * a global substitution turns ordinary prose into digit strings, which is the
 * root cause of the false-positive class this detector replaces.
 */
const preNormalizeForPhone = text => {
  const lower = `${text || ''}`
    .toLowerCase()
    .replace(/\[(at|dot)\]/gi, match => (match.toLowerCase() === '[at]' ? '@' : '.'))
    .replace(/\((at|dot)\)/gi, match => (match.toLowerCase() === '(at)' ? '@' : '.'));
  return countWordDigits(lower) >= 3 ? replaceWordDigits(lower) : lower;
};

const isDigitChar = char => char >= '0' && char <= '9';
const isHomoglyphChar = char => PHONE_HOMOGLYPHS.has(char);
const isSeparatorChar = char => PHONE_SEPARATORS.has(char);

const buildCandidate = (line, start, end) => {
  let literal = 0;
  let converted = 0;
  let groups = 0;
  let digits = '';
  let inGroup = false;
  for (let index = start; index < end; index += 1) {
    const char = line[index];
    if (isDigitChar(char)) {
      literal += 1;
      digits += char;
      if (!inGroup) {
        groups += 1;
        inGroup = true;
      }
    } else if (isHomoglyphChar(char)) {
      converted += 1;
      digits += PHONE_HOMOGLYPHS.get(char);
      if (!inGroup) {
        groups += 1;
        inGroup = true;
      }
    } else {
      inGroup = false;
    }
  }
  return {
    start,
    end,
    literal,
    converted,
    total: literal + converted,
    groups,
    digits,
    hasPlus: start > 0 && line[start - 1] === '+',
  };
};

/**
 * Candidate-first phone scanning over a single line.
 *
 * A candidate can only be seeded by a literal ASCII digit, and a homoglyph is
 * only admissible when it directly touches a literal digit. Homoglyphs can
 * therefore modify an existing candidate but can never create one out of
 * alphabetic prose.
 */
const findPhoneCandidates = line => {
  const length = line.length;
  const admissibleH = index => {
    if (index < 0 || index >= length || !isHomoglyphChar(line[index])) {
      return false;
    }
    const previous = index > 0 ? line[index - 1] : '';
    const next = index + 1 < length ? line[index + 1] : '';
    return isDigitChar(previous) || isDigitChar(next);
  };

  const candidates = [];
  let index = 0;
  while (index < length) {
    if (!isDigitChar(line[index])) {
      index += 1;
      continue;
    }
    let start = index;
    while (start > 0 && admissibleH(start - 1)) {
      start -= 1;
    }
    let end = index;
    while (end < length) {
      const char = line[end];
      if (isDigitChar(char)) {
        end += 1;
        continue;
      }
      if (isHomoglyphChar(char)) {
        if (!admissibleH(end)) {
          break;
        }
        end += 1;
        continue;
      }
      if (!isSeparatorChar(char)) {
        break;
      }
      let runEnd = end;
      while (runEnd < length && isSeparatorChar(line[runEnd])) {
        runEnd += 1;
      }
      const runLength = runEnd - end;
      const continuesWithDigit =
        runEnd < length && (isDigitChar(line[runEnd]) || admissibleH(runEnd));
      if (runLength > MAX_SEPARATOR_RUN || !continuesWithDigit) {
        break;
      }
      end = runEnd;
    }
    candidates.push(buildCandidate(line, start, end));
    index = end;
  }
  return candidates;
};

const isValidYear = value => value >= 1900 && value <= 2100;
const isValidMonth = value => value >= 1 && value <= 12;
const isValidDay = value => value >= 1 && value <= 31;

const validDateShape = digits => {
  if (digits.length !== 8) {
    return false;
  }
  const asYearFirst =
    isValidYear(Number(digits.slice(0, 4))) &&
    isValidMonth(Number(digits.slice(4, 6))) &&
    isValidDay(Number(digits.slice(6, 8)));
  const asDayFirst =
    isValidDay(Number(digits.slice(0, 2))) &&
    isValidMonth(Number(digits.slice(2, 4))) &&
    isValidYear(Number(digits.slice(4, 8)));
  return asYearFirst || asDayFirst;
};

const previousWord = (line, start) => {
  const window = line.slice(Math.max(0, start - 24), start);
  const match = window.match(PREVIOUS_WORD_REGEX);
  return match ? match[1].toLowerCase() : '';
};

const classifyPhoneCandidate = (candidate, line) => {
  const { start, end, literal, converted, total, groups, digits, hasPlus } = candidate;
  if (total < MIN_CANDIDATE_DIGITS) {
    return null;
  }

  const prefix = line.slice(Math.max(0, start - 20), start);
  const suffix = line.slice(end, end + 20);
  if (PRICE_PREFIX_REGEX.test(prefix) || PRICE_SUFFIX_REGEX.test(suffix)) {
    return null;
  }

  const isDateShaped =
    groups === 1 && converted === 0 && !hasPlus && literal === 8 && validDateShape(digits);
  if (isDateShaped) {
    const word = previousWord(line, start);
    if (DATE_CONTEXT.has(word)) {
      return null;
    }
    if (PHONE_CONTEXT.has(word)) {
      return 'block';
    }
    return 'suspicious';
  }

  if (literal >= BLOCK_MIN_LITERAL_DIGITS) {
    return 'block';
  }
  if (literal >= SUSPICIOUS_MIN_LITERAL_DIGITS) {
    return 'suspicious';
  }
  return null;
};

const analyzePhone = rawText => {
  const lines = preNormalizeForPhone(rawText).split(/[\r\n]/);
  let suspicious = false;
  for (const line of lines) {
    for (const candidate of findPhoneCandidates(line)) {
      const decision = classifyPhoneCandidate(candidate, line);
      if (decision === 'block') {
        return 'block';
      }
      if (decision === 'suspicious') {
        suspicious = true;
      }
    }
  }
  return suspicious ? 'suspicious' : null;
};

const hostFromSiteDomain = siteDomain => {
  const raw = `${siteDomain || ''}`.trim().toLowerCase();
  if (!raw) {
    return '';
  }
  const withoutScheme = raw.replace(/^[a-z][a-z0-9+.-]*:\/\//, '');
  const host = withoutScheme.split(/[/?#]/)[0].replace(/^www\./, '');
  return /^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/.test(host) ? host : '';
};

const matchesHost = (host, reference) =>
  !!reference && (host === reference || host.endsWith(`.${reference}`));

/**
 * Bare-domain detection. Runs on raw text (not phone-normalized text) so that
 * capitalization evidence survives, and never performs DNS or network lookups.
 */
const analyzeBareDomain = (rawText, siteDomain) => {
  const ownHost = hostFromSiteDomain(siteDomain);
  let suspicious = false;

  BARE_DOMAIN_REGEX.lastIndex = 0;
  let match = BARE_DOMAIN_REGEX.exec(rawText);
  while (match !== null) {
    const host = match[1];
    const pathOrQuery = match[2] || '';
    const hostLower = host.toLowerCase();
    const labels = hostLower.split('.');
    const tld = labels[labels.length - 1];

    const isHighConfidence = BARE_DOMAIN_HIGH_CONFIDENCE_TLDS.has(tld);
    const isAmbiguous = BARE_DOMAIN_AMBIGUOUS_TLDS.has(tld);
    const isExcluded =
      matchesHost(hostLower, ownHost) ||
      matchesHost(hostLower, 'stripe.com') ||
      STOP_WORDS.some(word => matchesHost(hostLower, word));

    if ((isHighConfidence || isAmbiguous) && !isExcluded) {
      if (isHighConfidence) {
        return 'block';
      }

      const rawLabels = host.split('.');
      const rawTld = rawLabels[rawLabels.length - 1];
      const rawPreviousLabel = rawLabels[rawLabels.length - 2] || '';
      // Only `lower.Title` and `lower.UPPER` read as sentence punctuation. A mixed-case
      // TLD such as `oNe` is neither, so it stays a domain candidate.
      const isTitleCaseTld = /^[A-Z][a-z]+$/.test(rawTld);
      const isUpperCaseTld = rawTld === rawTld.toUpperCase();
      const isSentenceBoundary =
        rawPreviousLabel === rawPreviousLabel.toLowerCase() && (isTitleCaseTld || isUpperCaseTld);

      if (!isSentenceBoundary) {
        const isAllCapsHost = host === host.toUpperCase() && host !== host.toLowerCase();
        const hasStrongEvidence = !!pathOrQuery || labels.length >= 3 || isAllCapsHost;
        if (hasStrongEvidence && ownHost) {
          return 'block';
        }
        suspicious = true;
      }
    }

    match = BARE_DOMAIN_REGEX.exec(rawText);
  }

  return suspicious ? 'suspicious' : null;
};

/**
 * Tri-state contact-sharing analysis.
 *
 * Precedence: hard scheme/www URL -> hard stop words -> hard email ->
 * hard bare domain -> hard phone -> suspicious domain -> suspicious phone.
 * At most one decision and at most one suspicious category per call.
 */
export const analyzeContactSharing = (message, siteDomain) => {
  const rawText = `${message || ''}`;
  const lowerText = rawText.toLowerCase();

  const urls = rawText.match(URL_REGEX) || [];
  if (urls.length > 0) {
    const allowedDomain = `${siteDomain || ''}`.toLowerCase();
    const allAllowed = urls.every(url => {
      const urlLower = url.toLowerCase();
      return (
        (allowedDomain && urlLower.includes(allowedDomain)) ||
        urlLower.includes('stripe.com')
      );
    });
    if (!allAllowed) {
      return { decision: 'block', reason: 'url' };
    }
  }

  const hasStopWord = STOP_WORDS.some(word => lowerText.includes(word));
  if (hasStopWord) {
    return { decision: 'block', reason: 'stop_words' };
  }

  if (EMAIL_REGEX.test(lowerText)) {
    return { decision: 'block', reason: 'email' };
  }

  const domain = analyzeBareDomain(rawText, siteDomain);
  if (domain === 'block') {
    return { decision: 'block', reason: 'url' };
  }

  const phone = analyzePhone(rawText);
  if (phone === 'block') {
    return { decision: 'block', reason: 'phone' };
  }

  if (domain === 'suspicious') {
    return { decision: 'suspicious', reason: 'url' };
  }
  if (phone === 'suspicious') {
    return { decision: 'suspicious', reason: 'phone' };
  }

  return { decision: 'pass', reason: '' };
};

/**
 * Binary enforcement contract. `suspicious` and `pass` are indistinguishable
 * here on purpose: suspicious must stay invisible to enforcement callers.
 */
export const checkViolation = (message, siteDomain) => {
  const { decision, reason } = analyzeContactSharing(message, siteDomain);
  return decision === 'block' ? { isViolated: true, reason } : { isViolated: false, reason: '' };
};
